import { render } from "./IncludedItemsStep.vue?vue&type=template&id=a1410580&scoped=true"
import script from "./IncludedItemsStep.vue?vue&type=script&lang=js"
export * from "./IncludedItemsStep.vue?vue&type=script&lang=js"

import "./IncludedItemsStep.vue?vue&type=style&index=0&id=a1410580&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1410580"]])

export default __exports__